import ReleveBonsController from './releve.bons.controller';

export default {
    template: require('./releve.bons.html'),
    controller: ReleveBonsController
};
